import { render, staticRenderFns } from "./preview-postView.vue?vue&type=template&id=73390770&scoped=true&"
import script from "./preview-postView.vue?vue&type=script&lang=js&"
export * from "./preview-postView.vue?vue&type=script&lang=js&"
import style0 from "./preview-postView.vue?vue&type=style&index=0&id=73390770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73390770",
  null
  
)

export default component.exports